import getRateAtDate from './getRateAtDate'
import _ from 'lodash'
import { addDays } from 'date-fns'

export default (rates, rateType, dateRange) => {
    const now = new Date()
    dateRange[0] ??= now
    dateRange[1] ??= now
    if (dateRange[0]?.getTime() === dateRange[1]?.getTime()) {
        return getRateAtDate(rates, rateType, dateRange[0])
    }
    const businessDays = getBusinessDaysBetweenDates(...dateRange)
    return _.mean(
        businessDays.map((d) => {
            return getRateAtDate(rates, rateType, d) || 0
        })
    )
}

const getBusinessDaysBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const businessDays = []
    let currentDate = start
    while (currentDate <= end) {
        const day = currentDate.getDay()
        if (![0, 6].includes(day)) {
            businessDays.push(currentDate)
        }
        currentDate = addDays(currentDate, 1)
    }
    return businessDays
}
